import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ChartDataSets } from 'chart.js';
import { Color, Label } from 'ng2-charts';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';

@Component({
  selector: 'app-view-dlr-summary-chart',
  templateUrl: './view-dlr-summary-chart.component.html',
  styleUrls: ['./view-dlr-summary-chart.component.scss']
})
export class ViewDlrSummaryChartComponent implements OnInit {

  lineChartDataType = 'MultiDataSet';
  lineChartData: ChartDataSets[] = [
    { data: [], fill: false, label: 'Delivered' },
    { data: [], fill: false, label: 'Undelivered' }
  ];

  lineChartLabels: Label[] = [];

  lineChartOptions = {
    responsive: true,
    legend: {display: false},
/*     scales: {
      yAxes: [{
        ticks: {
            beginAtZero: true
        }
      }]
    }, */
  };

  lineChartColors: Color[] = [
    {
      borderColor: '#2e72b0',
    },
    {
      borderColor: '#696969',
    },
  ];

  lineChartLegend = false;
  lineChartPlugins = [];
  lineChartType = 'line';

  constructor(@Inject(MAT_DIALOG_DATA) public data) { }

  ngOnInit(): void {
    console.log(this.data);
    this.lineChartData[0].data = this.data.data.map(d => d.delivered);
    this.lineChartData[1].data = this.data.data.map(d => d.undelivered);
    this.lineChartLabels = this.data.data.map(d => d.time);
  }

/*   saveInPDF() {
    // printDiv is the html element which has to be converted to PDF
    const data = document.getElementById('htmlData');
    html2canvas(data).then(canvas => {
      const pdfFile = new jsPDF('p', 'pt', [canvas.width, canvas.height]);
      const imgData  = canvas.toDataURL('image/jpeg', 1.0);
      pdfFile.addImage(imgData,0,0,canvas.width, canvas.height);
      pdfFile.save('sample.pdf');
    });
  } */

  public ExtractPDF() {
    const data = document.getElementById('htmlData');
    const divHeight = data.clientHeight;
    const divWidth = data.clientWidth;
    const ratio = divHeight / divWidth;
    console.log(divHeight, divWidth, ratio);
    html2canvas(data,
      {
        height: window.outerHeight + window.innerHeight,
        width: window.outerWidth + window.innerWidth,
        windowHeight: window.outerHeight + window.innerHeight,
        windowWidth: window.outerWidth + window.innerWidth,
        scrollX: 0,
        scrollY: 0
      }
      ).then(canvas => {
        const pdf = new jsPDF('p', 'mm', 'a4');
        const imgData = canvas.toDataURL('image/png');
        const width = pdf.internal.pageSize.getWidth();
        const height = pdf.internal.pageSize.getHeight();
        console.log(width, height);
        pdf.addImage(imgData, 'PNG', 10, 10, 820, 460/* width, height*ratio */);
        pdf.save('filename.pdf');
    });
  }

}
